/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import {HIDE_MODAL, MODAL_STATUS_UPDATE} from '../_actions/modal.actions';

export const INITIAL_STATE = {
    isModalOpen: false,
    hideModal: false
};

export function modalReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case MODAL_STATUS_UPDATE: {
            return {...state, isModalOpen:action.payload, hideModal:!action.payload};
        }
        case HIDE_MODAL: {
            return {...state, hideModal:true};
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/modal.reducer.js